/* The 19 permission modules (must match the API's src/services/permissions.js keys). */
export const PERMISSION_MODULES = [
    { key: 'dashboard', label: 'Dashboard' },
    { key: 'users', label: 'Users List' },
    { key: 'inactiveUsers', label: 'Inactive Users' },
    { key: 'deletedAccounts', label: 'Deleted Accounts' },
    { key: 'dailyReports', label: 'Daily Reports' },
    { key: 'bidReports', label: 'Win / Place Bid Reports' },
    { key: 'bidUpdateReports', label: 'Bid Update Reports' },
    { key: 'bulkWithdrawals', label: 'Bulk Withdrawals' },
    { key: 'withdrawals', label: 'Withdrawals List' },
    { key: 'transactions', label: 'Market Transactions' },
    { key: 'addMoney', label: 'Add Money' },
    { key: 'paymentStatus', label: 'Payment Status' },
    { key: 'markets', label: 'Markets List' },
    { key: 'noticeBoard', label: 'Notice Board' },
    { key: 'notifications', label: 'Notifications' },
    { key: 'uploadApk', label: 'Upload APK' },
    { key: 'settings', label: 'Settings' },
    { key: 'subAdmins', label: 'Roles & Permissions' },
    { key: 'clearData', label: 'Clear Data' },
];

export const ACTIONS = ['read', 'write', 'delete'];

export function defaultPermissions(value = false) {
    const p = {};
    PERMISSION_MODULES.forEach((m) => { p[m.key] = { read: value, write: value, delete: value }; });
    return p;
}

/* Merge a (possibly partial/legacy) permissions object into the full 19-module shape. */
export function mergePermissions(existing) {
    const base = defaultPermissions(false);
    if (existing && typeof existing === 'object') {
        PERMISSION_MODULES.forEach((m) => {
            if (existing[m.key]) {
                base[m.key] = {
                    read: !!existing[m.key].read,
                    write: !!existing[m.key].write,
                    delete: !!existing[m.key].delete
                };
            }
        });
    }
    return base;
}
